import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const OnboardingSteps = ({ activeStep }) => {
  const token = useSelector(({ watchlistReducer }) => (
    watchlistReducer.userToken
  ));

  const stepsClass = cx({
    steps: true,
    'watchlist-step': activeStep === 'Watchlist',
    'preferences-step': activeStep === 'Preferences',
    'register-step': activeStep === 'Register',
  });

  const checkedStep = (
    <div className={cx('step-circle')}>
      <FontAwesomeIcon icon={faCheck} />
    </div>
  );

  const getStepCircle = (stepVal) => {
    if (activeStep === 'Preferences' && stepVal === 'watchlist') return checkedStep;
    if (activeStep === 'Preferences' && stepVal === 'register') return <div className={Styles['step-circle']}>3</div>;
    if (activeStep === 'Watchlist' && stepVal === 'preferences') return <div className={Styles['step-circle']}>2</div>;
    if (activeStep === 'Watchlist' && stepVal === 'register') return <div className={Styles['step-circle']}>3</div>;
    if (activeStep === 'Register') return checkedStep;
  };

  return (
    <div className={stepsClass}>
      <div className={cx('step', { active: activeStep === 'Watchlist' }, {
        'step-circle-checked': activeStep === 'Register'
          || { 'step-circle-checked': activeStep === 'Preferences' },
      })}
      >
        {activeStep === 'Watchlist' ? (
          <div className={Styles['step-circle']}>1</div>
        ) : getStepCircle('watchlist')}
        {activeStep !== 'Watchlist' && (
          <>
            <h4>Watchlists</h4>
            <h4 className={Styles.mobile}>
              Watchlists
            </h4>
          </>
        )}
      </div>
      <div className={cx('step', { active: activeStep === 'Preferences' }, { 'step-circle-checked': activeStep === 'Register' })}>
        {activeStep === 'Preferences' ? (
          <div className={Styles['step-circle']}>2</div>
        ) : getStepCircle('preferences')}
        {activeStep !== 'Preferences' && (
          <>
            <h4>Preferences</h4>
            <h4 className={Styles.mobile}>Preferences</h4>
          </>
        )}
      </div>
      <div className={cx('step', { active: activeStep === 'Register' })}>
        {activeStep === 'Register' ? (
          <div className={Styles['step-circle']}>3</div>
        ) : getStepCircle('register')}
        {activeStep !== 'Register' && (
          <>
            <h4>{token ? 'Finish' : 'Register'}</h4>
            <h4 className={Styles.mobile}>
              {token ? 'Finish' : 'Register'}
            </h4>
          </>
        )}
      </div>
    </div>
  );
};

export default withComponentName(OnboardingSteps);
